import React, { Fragment, useState, useEffect, useRef } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, TabContent, TabPane, Label, Input,Table } from 'reactstrap'

import { createClient } from "@supabase/supabase-js";
import { toast } from 'react-toastify';
import { ReactBingmaps } from "react-bingmaps";
import { Icon } from '@iconify/react';
import { useTranslation } from "react-i18next";

import "./styles.css"
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const Map = (props) => {



    const { t } = useTranslation();

    const [activeTab1, setActiveTab1] = useState('1');

    const [trip_detail, settrip_detail] = useState([]);
    const [filtertriparr, setfiltertriparr] = useState([]);


    const [trip_id, settrip_id] = useState("");
    const count = useRef(0);

    const [rightSidebar, setRightSidebar] = useState(true);
    const openCustomizer = (type) => {

        setActiveTab1(type)
        setRightSidebar(!rightSidebar)
        if (rightSidebar) {
            document.querySelector(".customizer-contain").classList.add('open');

        }
    }
    const closeCustomizer = () => {
        setRightSidebar(!rightSidebar)
        document.querySelector(".customizer-contain").classList.remove('open');

    }
    useEffect(() => {


        count.current = 0

        setTimeout(() => {
            getTripDetail()
        }, 5000)



    }, [])

    async function filtertrip(id) {

        let { data: trip_Details, error } = await supabase
            .from('trip_details')
            .select('*')
            .eq("trip_id", id)
            .order('id', { ascending: false })
        settrip_id(id)

        setfiltertriparr(trip_Details)





    }
    async function getTripDetail() {
        if (localStorage.getItem("usertype") == "Supplier") {
            let { data: trip_Details, error } = await supabase
                .from('trip_details')
                .select('*')
                .eq("createdBy", localStorage.getItem("useremail"))
                .order('id', { ascending: false })

            if (trip_Details !== null && trip_Details.length > 0) {
                var arr = []
                if (trip_id == "") {
                    for (var i = 0; i < trip_Details.length; i++) {
                        if (trip_Details[i].driver_coordinates !== null) {
                            arr.push(trip_Details[i])
                        }
                    }
                }

                settrip_detail(arr)


            } else {
                // toast.error("No Buyer Details Found")
                settrip_detail([])

            }
        } else if (localStorage.getItem("usertype") == "Buyer") {
            let { data: trip_Details, error } = await supabase
                .from('trip_details')
                .select('*')
                .eq("customer_id", localStorage.getItem("userid"))
                .order('id', { ascending: false })

            if (trip_Details !== null && trip_Details.length > 0) {
                var arr = []
                if (trip_id == "") {
                    for (var i = 0; i < trip_Details.length; i++) {
                        if (trip_Details[i].driver_coordinates !== null) {
                            arr.push(trip_Details[i])
                        }
                    }
                }

                settrip_detail(arr)


            } else {
                // toast.error("No Buyer Details Found")
                settrip_detail([])

            }
        } else if (localStorage.getItem("usertype") == "Driver") {
            let { data: trip_Details, error } = await supabase
                .from('trip_details')
                .select('*')
                .eq("driverid", localStorage.getItem("userid"))
                .order('id', { ascending: false })

            if (trip_Details !== null && trip_Details.length > 0) {
                var arr = []
                if (trip_id == "") {
                    for (var i = 0; i < trip_Details.length; i++) {
                        if (trip_Details[i].driver_coordinates !== null) {
                            arr.push(trip_Details[i])
                        }
                    }
                }

                settrip_detail(arr)


            } else {
                // toast.error("No Buyer Details Found")
                settrip_detail([])

            }
        } else {
            let { data: trip_Details, error } = await supabase
                .from('trip_details')
                .select('*')
                .eq("vehicle_id", localStorage.getItem("userid"))
                .order('id', { ascending: false })

            if (trip_Details !== null && trip_Details.length > 0) {
                var arr = []
                if (trip_id == "") {
                    for (var i = 0; i < trip_Details.length; i++) {
                        if (trip_Details[i].driver_coordinates !== null) {
                            arr.push(trip_Details[i])
                        }
                    }
                }

                settrip_detail(arr)


            } else {
                // toast.error("No Buyer Details Found")
                settrip_detail([])

            }
        }

    }







    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
    const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
    const supabase = createClient(supabaseUrl, supabaseKey);








    return (
        <Fragment>
            <Breadcrumb parent="Users" title="Map Details" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <div className="customizer-contain">
                            <div className="tab-content" id="c-pills-tabContent">
                                <div className="customizer-header">
                                    <i className="icon-close" onClick={closeCustomizer}></i>
                                    <h5>{t("filter")}</h5>



                                </div>
                                <div className="customizer-body custom-scrollbar">
                                    <TabContent activeTab={activeTab1}>
                                        <TabPane tabId="1">
                                            <Row>
                                                <Col sm="12" style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
                                                    <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer", backgroundColor: "#e8e8e8", padding: "5px 10px", borderRadius: "20px" }} onClick={() => {
                                                        settrip_id(""); getTripDetail(); setfiltertriparr([])
                                                    }}>{t("Clear")}</div>

                                                </Col>
                                                <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                                                    <Label for="exampledate">{t("Trip")}</Label>

                                                    <div style={{ textAlign: "center" }}>
                                                        <Input className="form-control" type="select" value={trip_id} onChange={(e) => {
                                                            filtertrip(e.target.value)

                                                            settrip_id(e.target.value)



                                                        }}>
                                                            <option value={""}>Choose Trip </option>
                                                            {trip_detail.map((data, i) => {

                                                                return (
                                                                    <option key={i} value={data.trip_id} >{data.trip_date} {data.driver_name}</option>
                                                                )
                                                            })}
                                                        </Input>
                                                    </div>
                                                </Col>






                                                <Col sm="12" style={{ display: "flex", justifyContent: "center", margin: "10px" }}>

                                                    <div style={{ textAlign: "center" }}>
                                                        <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "5px" }} onClick={() => { closeCustomizer(); }}>{t("Show Result")} {trip_id !== "" ? filtertriparr.length : ""} </button>
                                                    </div>


                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </div>
                        <Card>
                            <CardBody>
                                {window.innerWidth < 881 ?
                                    <div onClick={() => { openCustomizer('1') }} style={{ display: "flex", alignItems: "center", cursor: "pointer", position: "absolute", top: "-44px", right: "20px" }}>
                                        <Icon icon="bx:filter" color="black" width="35" height="35" />
                                    </div> :
                                    <div className="table-responsive ">
                                        <Table className='table-borderless'>
                                            <tbody>
                                                <tr style={{ display: "flex", alignItems: "center" }}>
                                                    <td style={{ verticalAlign: "inherit" }}>
                                                        <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer" }} onClick={() => {
                                                            settrip_id(""); getTripDetail(); setfiltertriparr([])
                                                        }}>All</div>
                                                    </td>
                                                    <td>
                                                        <div style={{ textAlign: "center" }}>
                                                            <Input className="form-control" type="select" value={trip_id} onChange={(e) => {
                                                                filtertrip(e.target.value)

                                                                settrip_id(e.target.value)



                                                            }}>
                                                                <option value={""}>Choose Trip </option>
                                                                {trip_detail.map((data, i) => {

                                                                    return (
                                                                        <option key={i} value={data.trip_id} >{data.trip_date} {data.driver_name}</option>
                                                                    )
                                                                })}
                                                            </Input>
                                                        </div>
                                                    </td>










                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                }


                                <br />
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", zIndex: "1" }}>
                                    {trip_id !== "" ? <>{filtertriparr.length > 0 && filtertriparr.map((item, i) => {

                                        return item.driver_coordinates !== null && item.driver_coordinates !== "" && item.Buyer_coordinate === null || item.Buyer_coordinate === "" ? (

                                            <div className='map-three' key={i} >
                                                <ReactBingmaps
                                                    id={i}
                                                    center={[28.750591076255212, 77.20027622752754]}
                                                    zoom={7}
                                                    className="customClass"
                                                    bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                                    pushPins={[





                                                        {
                                                            location: [parseFloat(item.driver_coordinates.split(",")[1]), parseFloat(item.driver_coordinates.split(",")[0])],
                                                            option: { title: item.driver_name, subTitle: "Driver" },


                                                        },
                                                        {
                                                            location: [parseFloat(item.supplier_coordinate.split(",")[1]), parseFloat(item.supplier_coordinate.split(",")[0])],
                                                            option: { title: item.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                        },
                                                        // {
                                                        //     location: [parseFloat(item.Buyer_coordinate.split(",")[1]), parseFloat(item.Buyer_coordinate.split(",")[0])],
                                                        //     option: { title: item.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                        // }
                                                    ]
                                                    }















                                                />
                                            </div>) : item.Buyer_coordinate !== null && item.Buyer_coordinate !== "" && item.driver_coordinates !== null && item.driver_coordinates !== "" ? (

                                                <div className='map-three' key={i} >
                                                    <ReactBingmaps
                                                        id={i}
                                                        center={[28.750591076255212, 77.20027622752754]}
                                                        zoom={7}
                                                        className="customClass"
                                                        bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                                        pushPins={[





                                                            {
                                                                location: [parseFloat(item.driver_coordinates.split(",")[1]), parseFloat(item.driver_coordinates.split(",")[0])],
                                                                option: { title: item.driver_name, subTitle: "Driver" },


                                                            },
                                                            {
                                                                location: [parseFloat(item.supplier_coordinate.split(",")[1]), parseFloat(item.supplier_coordinate.split(",")[0])],
                                                                option: { title: item.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                            },
                                                            {
                                                                location: [parseFloat(item.Buyer_coordinate.split(",")[1]), parseFloat(item.Buyer_coordinate.split(",")[0])],
                                                                option: { title: item.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                            }
                                                        ]
                                                        }















                                                    />
                                                </div>) : (

                                            <div className='map-three' key={i} >
                                                <ReactBingmaps
                                                    id={i}
                                                    center={[28.750591076255212, 77.20027622752754]}
                                                    zoom={7}
                                                    className="customClass"
                                                    bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                                    pushPins={[





                                                        // {
                                                        //     location: [parseFloat(item.driver_coordinates.split(",")[1]), parseFloat(item.driver_coordinates.split(",")[0])],
                                                        //     option: { title: item.driver_name, subTitle: "Driver" },


                                                        // },
                                                        {
                                                            location: [parseFloat(item.supplier_coordinate.split(",")[1]), parseFloat(item.supplier_coordinate.split(",")[0])],
                                                            option: { title: item.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                        },
                                                        // {
                                                        //     location: [parseFloat(item.Buyer_coordinate.split(",")[1]), parseFloat(item.Buyer_coordinate.split(",")[0])],
                                                        //     option: { title: item.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                        // }
                                                    ]
                                                    }















                                                />
                                            </div>);
                                    })}</>
                                        : <div className='map-three' >
                                            <ReactBingmaps
                                                id="nocoords"
                                                center={[23.9966015723219, 77.55731591266179]}
                                                zoom={5}
                                                className="customClass"
                                                bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                                pushPins={
                                                    trip_detail.length > 0 && trip_detail.map((item) => {
                                                        return (




                                                            {
                                                                location: [parseFloat(item.driver_coordinates.split(",")[1]), parseFloat(item.driver_coordinates.split(",")[0])],
                                                                option: { title: item.driver_name, subTitle: "Driver" },


                                                            }
                                                            // {
                                                            //     location: [parseFloat(item.supplier_coordinate.split(",")[1]), parseFloat(item.supplier_coordinate.split(",")[0])],
                                                            //     option: { title: item.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                            // },
                                                            // {
                                                            //     location: [parseFloat(item.Buyer_coordinate.split(",")[1]), parseFloat(item.Buyer_coordinate.split(",")[0])],
                                                            //     option: { title: item.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                                            // }









                                                        );
                                                    })


                                                }


                                            />
                                        </div>}
                                </div>




                                {/* <div className='map-three' >
                                         <ReactBingmaps

                                            center={[28.750591076255212, 77.20027622752754]}
                                            zoom={7}
                                            className="customClass"
                                            bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}
                                            getLocation={
                                                { addHandler: "click", callback: AddPushPinOnClick }
                                            }
                                            infoboxesWithPushPins={
                                                pushpinarr.length > 0 && pushpinarr.map((item) => {
                                                    return (
                                                        {


                                                            location: [item.latitude, item.longitude],
                                                            addHandler: "mouseover", //on mouseover the pushpin, infobox shown
                                                            infoboxOption: { title: item.title, description: item.description },
                                                            pushPinOption: { title: item.title, description: item.description },

                                                        }
                                                    );
                                                })


                                            }


                                        />
                                    </div> */}



                                <br />

                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </Container>
        </Fragment >
    );
}

export default Map;